var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { When, TextUtil, Avatar } from '@alife/simple-ui';
var historyFallback = 'https://sg-live.slatic.net/original/ebf238e7aa294b55f5198f2a709efa42.png';
var tagIconMap = {
    'official': React.createElement("img", { className: "user-tag-icon", src: "https://sg-test-11.slatic.net/shop/e10a79438c7a683bf0ef353f3d829f57.png", alt: "officail" })
};
var SessionItem = (function (_super) {
    __extends(SessionItem, _super);
    function SessionItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onDelete = _this.onDelete.bind(_this);
        return _this;
    }
    SessionItem.prototype.shouldComponentUpdate = function (nextProps) {
        var currProps = this.props;
        return currProps.active !== nextProps.active
            || currProps.draft !== nextProps.draft
            || currProps.item.nonReadNumber !== nextProps.item.nonReadNumber
            || currProps.item.content !== nextProps.item.content
            || currProps.item.viewModifyTime !== nextProps.item.viewModifyTime
            || currProps.keyword !== nextProps.keyword
            || currProps.top !== nextProps.top;
    };
    SessionItem.prototype.onDelete = function (e) {
        e.stopPropagation();
        var _a = this.props, item = _a.item, deleteSession = _a.deleteSession;
        deleteSession(item);
    };
    SessionItem.prototype.formateTitle = function (title, keyword) {
        if (keyword === void 0) { keyword = ''; }
        if (!keyword) {
            return title;
        }
        var regex = new RegExp(keyword, 'gi');
        var newContent = title.replace(regex, function (key) { return "<span class=\"high-light\">" + key + "</span>"; });
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: newContent } });
    };
    SessionItem.prototype.render = function () {
        var _a = this.props, active = _a.active, item = _a.item, draft = _a.draft, onClick = _a.onClick, locale = _a.locale, deleteSession = _a.deleteSession, IconDelete = _a.IconDelete, keyword = _a.keyword, avatarFallbackUrl = _a.avatarFallbackUrl, top = _a.top;
        var fallbackUrl = avatarFallbackUrl || historyFallback;
        var avatarUrl = historyFallback === item.headUrl ? fallbackUrl : item.headUrl;
        var firstTag = item.tags ? item.tags[0] : '';
        var tagIcon = tagIconMap[firstTag];
        return (React.createElement("div", { className: "session-item active-" + active + " ripple", onClick: onClick, style: { top: top } },
            React.createElement("div", { className: "avatar-box" },
                React.createElement(Avatar, { src: avatarUrl, alt: "avatar", fallbackSrc: fallbackUrl }),
                tagIcon),
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "title" }, this.formateTitle(item.title, keyword)),
                    firstTag && React.createElement("span", { className: "user-tag", id: firstTag }, firstTag),
                    React.createElement("div", { className: "date" }, TextUtil.getFriendlyDate(item.viewModifyTime))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "desc text-two-lines" }, draft ?
                        React.createElement("span", null,
                            "[",
                            locale.draft,
                            "]",
                            draft) :
                        item.content),
                    React.createElement(When, { condition: !!item.nonReadNumber && !active },
                        React.createElement("div", { className: "badge" }, TextUtil.maxNumberStr(item.nonReadNumber)))),
                deleteSession && !!IconDelete &&
                    React.createElement("div", { className: "btn-delete" },
                        React.createElement(IconDelete, { onClick: this.onDelete })))));
    };
    SessionItem.defaultProps = {
        active: false,
        deleteSession: function () { },
    };
    return SessionItem;
}(React.Component));
export default SessionItem;
//# sourceMappingURL=index.js.map